/**
 * urgency-timer.js
 * Custom element <urgency-timer-component> usado por blocks/urgency-scarcity.liquid
 *
 * Cuenta atrás desde N minutos. Para que no se note "reseteada" en cada
 * recarga de página, la hora de fin se guarda en sessionStorage: mientras
 * dure la sesión del navegador, el contador sigue bajando de forma
 * coherente en vez de reiniciarse a los mismos minutos cada vez.
 */
class UrgencyTimerComponent extends HTMLElement {
  connectedCallback() {
    this.minutes = parseInt(this.getAttribute('data-minutes'), 10) || 15;
    this.storageKey = `urgency-timer-${this.getAttribute('data-key') || 'default'}`;
    this.display = this.querySelector('[ref="display"]');

    this.endTime = this.getEndTime();
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  getEndTime() {
    const stored = sessionStorage.getItem(this.storageKey);
    const now = Date.now();

    if (stored && parseInt(stored, 10) > now) {
      return parseInt(stored, 10);
    }

    const end = now + this.minutes * 60 * 1000;
    sessionStorage.setItem(this.storageKey, String(end));
    return end;
  }

  tick() {
    const remaining = Math.max(0, this.endTime - Date.now());

    if (remaining <= 0) {
      // Al llegar a cero, se reinicia la cuenta para mantener la sensación
      // de urgencia en visitas largas, en vez de quedarse clavado en 00:00.
      this.endTime = Date.now() + this.minutes * 60 * 1000;
      sessionStorage.setItem(this.storageKey, String(this.endTime));
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (this.display) {
      this.display.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  }
}

if (!customElements.get('urgency-timer-component')) {
  customElements.define('urgency-timer-component', UrgencyTimerComponent);
}
